import React from 'react'
import { withRouter } from "react-router";
import tickIcon from '../../../assets/images/arya_tickicon.png';
import MultiLanguageTranslation from '../../../_components/Translate/MultiLangTranslate'

class ServiceBanner extends React.Component {
    
    render() {
        return <React.Fragment>
           <section className="ourServicesBanner">
               <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ourServices-banner">
                                <div className="ourServices-banner-heading">
                                    {/* <h2><MultiLanguageTranslation title="9600+ Warehouses Across 800+ Locations" /></h2> */}
                                    <h2>{localStorage.getItem('warehouseCount') ? localStorage.getItem('warehouseCount') + '+' : '9600+'}<MultiLanguageTranslation title=" Warehouses Across " />{localStorage.getItem('districtCount') ? localStorage.getItem('districtCount') + '+' : '800+'}<MultiLanguageTranslation title=" Locations" /></h2>
                                </div>
                                <div className="ourServices-banner-desc">
                                    <ul>
                                        <li><a className="d-flex align-items-center" href="/our-services/storage-logistics">
                                            <img src={tickIcon} alt="icon" className="img-fluid" />
                                            <div><MultiLanguageTranslation title="Storage & Logistics Solutions" /></div> 
                                            </a>
                                        </li>
                                        <li>
                                            <a className="d-flex align-items-center" href="/our-services/Audits-Serveillance">
                                                <img src={tickIcon} alt="icon" className="img-fluid" /> 
                                                <div><MultiLanguageTranslation title="Audits & Surveillence" /></div>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="d-flex align-items-center" href="/arjun">
                                                <img src={tickIcon} alt="icon" className="img-fluid" />
                                                <div style={{"lineHeight":"25px"}}><MultiLanguageTranslation title="Arjun - Procurement Facilitation" /></div>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="d-flex align-items-center" href="/our-services/Consulting">
                                                <img src={tickIcon} alt="icon" className="img-fluid" /> 
                                                <div><MultiLanguageTranslation title="Consulting" /></div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
               </div>
           </section>
        </React.Fragment>
    }
}


export default withRouter(ServiceBanner)